import { render } from "./goldMall.vue?vue&type=template&id=35ee639c&scoped=true"
import script from "./goldMall.vue?vue&type=script&lang=js"
export * from "./goldMall.vue?vue&type=script&lang=js"

import "./goldMall.vue?vue&type=style&index=0&id=35ee639c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ee639c"]])

export default __exports__